import Sticky from "Components/Sticky/index";
import React, { Component } from "react";
import { MdLocationPin } from "react-icons/md";
import { BsTruck, BsFillPersonCheckFill, BsPersonFill } from "react-icons/bs";
import { AiOutlineProfile } from "react-icons/ai";
import { MdOutlineSecurity } from "react-icons/md";
import { ReactComponent as Back } from "Icons/back.svg";

class DbCostEstimation extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Sticky>
        <div className="main-div" style={{ maxWidth: "2000px" }}>
          <div className="arrow-text" style={{ cursor: "pointer" }}>
            <div onClick={() => { this.props.history.push('/createNewContracts') }}>
              <Back className="fill-theme mr-5" />
            </div>
            <div className="header-text" style={{ color: "#528aea" }}>
              Back
            </div>
          </div>

          <div style={{ borderBottom: "1px solid black", paddingBottom: "20px" }}>
            <div>
              <div style={{ display: "flex", gap: "80px", alignItems: "center", paddingTop: "15px" }}>
                <div style={{ fontSize: "20px", borderRight: "1px solid black", paddingRight: "80px" }}>
                  <strong>Estinated Cost</strong>: $ 10,50,000
                </div>
                <div style={{ fontSize: "20px", borderRight: "1px solid black", paddingRight: "80px" }}>
                  <strong>Cost/PTPK</strong>: $1430 PTPK
                </div>
                <div style={{ fontSize: "20px" }}>
                  <strong>Cost/MT</strong>: $200 per MT
                </div>
              </div>
            </div>
          </div>

          <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "20px" }
          }>
            <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color">
              <tr className="br-10">
                <th className=''></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
              {/* FIRST TABLE */}
              <tr>
                <td style={{ borderRight: "0px solid" }} className="tLeft p-5 pl-10  master-contract-font-color">
                  <div style={{ color: "blue" }}>
                    <div><BsTruck size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Transporters</span>
                    </div>
                  </div>
                </td>

                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={{ borderRight: "0px solid" }} className="tLeft p-5 pl-10  master-contract-font-color">
                  <div style={{ color: "blue" }}>
                    <div><BsTruck size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Transporters</span>
                    </div>
                  </div>
                </td>

                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={{ borderRight: "0px solid" }} className="tLeft p-5 pl-10  master-contract-font-color">
                  <div style={{ color: "blue" }}>
                    <div><BsTruck size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Transporters</span>
                    </div>
                  </div>
                </td>

                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={{ borderRight: "0px solid" }} className="tLeft p-5 pl-10  master-contract-font-color">
                  <div style={{ color: "blue" }}>
                    <div><BsTruck size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Transporters</span>
                    </div>
                  </div>
                </td>

                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={{ borderRight: "0px solid" }} className="tLeft p-5 pl-10  master-contract-font-color">
                  <div style={{ color: "blue" }}>
                    <div><BsTruck size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Transporters</span>
                    </div>
                  </div>
                </td>

                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
                <td style={{ paddingTop: "20px" }}>
                <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>


            {/* <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color bg-color">

                <div style={{ padding: "15px", display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                  <div style={{ color: "blue", width: "15%" }}>
                    <div><BsTruck size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Transporters</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "15px", display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                  <div style={{ color: "blue", width: "15%" }}>
                    <div><BsFillPersonCheckFill size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Surveyors</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "15px", display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                  <div style={{ color: "blue", width: "15%" }}>
                    <div><BsPersonFill size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Handling Agents</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "15px", display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                  <div style={{ color: "blue", width: "15%" }}>
                    <div><AiOutlineProfile size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Lashers</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "15px", display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                  <div style={{ color: "blue", width: "15%" }}>
                    <div><MdOutlineSecurity size="1.5em" /></div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "5px", gap: "5px" }}>
                      <span>Security</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>

                  <div>
                    <div>Transporter 1</div>
                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "5px", fontSize: "12px" }}>
                      <span>Cost: 200$ per MT</span>
                      <span>Total Est. Cost : $ 10000</span>
                    </div>
                  </div>
                </div>


              </tbody> */}

          </table>

        </div>
      </Sticky>
    )
  }
}

export default DbCostEstimation;